import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { INFINITE_CACHE_AND_STALE_TIME } from 'constants/index';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { generateURL } from 'utilities/hooks/urlGeneration';

import type {
  ChatMessageRatingTypeResponse,
  ChatMessageRatingType,
} from 'types/entityTypes/ChatMessageRatingType';

export const getChatMessageRatingTypes = () => {
  const url = generateURL(SPARK_RESOURCE_TYPES.CHAT_MESSAGE_RATING_TYPES);
  return fetchWrapper<ChatMessageRatingTypeResponse>({
    url: url,
    method: 'GET',
  });
};

export function useChatMessageRatingTypes() {
  const { data, ...rest } = useQuery(
    SPARK_RESOURCE_TYPES.CHAT_MESSAGE_RATING_TYPES,
    getChatMessageRatingTypes,
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(
            `failed to Fetch Chat Message Rating Types: ${error.message}`
          );
        }
      },
      ...INFINITE_CACHE_AND_STALE_TIME,
    }
  );

  const { data: responseData, ...restData } = data || {};

  const idMap = responseData?.reduce<Record<string, ChatMessageRatingType>>(
    (acc, curr) => {
      return { ...acc, [curr.id]: curr };
    },
    {}
  );

  return {
    chatMessageRatingTypes: responseData,
    idMap,
    ...restData,
    ...rest,
  };
}
